const listeners = new Set<() => void>();

export function subscribeScrollVisibility(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifyScrollVisibility() {
  listeners.forEach((listener) => {
    listener();
  });
}
